import { fileViewerAtom, fileViewerFunctionAtom } from 'js/file_viewer/core/atoms/atom';
export const isEditorReadyAtom = fileViewerAtom(false);
export const hasEditorChangesAtom = fileViewerAtom(false);
export const editorCanSaveAtom = fileViewerAtom(false);
export const onSaveReplaceAtom = fileViewerFunctionAtom();
export const onSaveCopyAtom = fileViewerFunctionAtom();
export const onCancelAtom = fileViewerFunctionAtom();
export const onCloseAtom = fileViewerFunctionAtom();
export const editorActivationParamsAtom = fileViewerAtom(undefined);
/**
 * Which editor is currently active. Undefined if no editor is active.
 */
export const activeEditorIdAtom = fileViewerAtom(undefined, (_get, set, newActiveEditorId, pluginActivationParams) => {
    set(activeEditorIdAtom, newActiveEditorId, pluginActivationParams);
    set(editorActivationParamsAtom, pluginActivationParams);
});
//# sourceMappingURL=editing.preenvesnextjs.map
